<template>
  <div class="login_page">
    <div class="login-bg">
      <img src="../../../static/page-bg.png" />
    </div>

    <div class="login-content">
      <p class="login-tit">熟客惠后台管理</p>

      <div class="cot_put_box">
        <el-input class="cot_put" v-model.trim="account" clearable placeholder="帐号" autocomplete="username"></el-input>

        <el-input class="cot_put" v-model.trim="password" clearable placeholder="密码" show-password
          autocomplete="current-password" @keyup.enter.native="login"></el-input>
      </div>

      <el-button class="login-lg-btn" type="primary" :loading="loading" @click="login">
        登录
      </el-button>

      <p class="login-tip">熟客惠后台管理登录</p>
    </div>

    <cps-foot></cps-foot>
  </div>
</template>

<script>
import axios from "axios";

// ✅ 走代理：/api -> https://www.jikecc.com（config/index.js 里 proxyTable 配好）
// var API_PWD_LOGIN = "api/login/pwdLogin";
var API_PWD_LOGIN = "https://www.jikecc.com/api/login/pwdLogin";

export default {
  data() {
    return {
      account: "",
      password: "",
      loading: false,
      _keydownHandler: null,
    };
  },

  created() {
    var that = this;
    this._keydownHandler = function (e) {
      var evt = e || window.event;
      var key = evt.keyCode || evt.which;
      if (key === 13) that.login();
    };
    document.addEventListener("keydown", this._keydownHandler);
  },

  beforeDestroy() {
    if (this._keydownHandler) {
      document.removeEventListener("keydown", this._keydownHandler);
      this._keydownHandler = null;
    }
  },

  methods: {
    login: function () {
      var that = this;
      if (that.loading) return;

      if (!that.account) {
        that.$message.error("请输入帐号");
        return;
      }
      if (!that.password) {
        that.$message.error("请输入密码");
        return;
      }

      that.loading = true;

      axios.get(API_PWD_LOGIN, {
        params: {
          account: that.account,
          password: that.password,
        },

        // ✅ 关键：让后端写入 satoken cookie，后续接口自动带 cookie
        withCredentials: true,

        timeout: 15000,
      })
        .then(function (res) {
          var data = res && res.data ? res.data : {};

          if (data.code === 0) {
            that.$message({
              showClose: true,
              message: data.msg || "登录成功",
              type: "success",
            });

            var payload = data.data ? data.data : {};
            var role = payload.role || payload.roles || [];

            // ✅ 只存 role（你页面要做权限判断）
            localStorage.setItem("role", JSON.stringify(role || []));

            // ✅ 不存 token（避免和 cookie 冲突导致 token 无效）
            localStorage.removeItem("token");

            that.pdPower(JSON.stringify(role || []));
          } else {
            that.$message.error(data.msg || "登录失败");
          }
        })
        .catch(function (err) {
          console.log(err);
          that.$message.error("请求失败（可能是跨域/CORS 或网络异常）");
        })
        .finally(function () {
          that.loading = false;
        });
    },

    // ✅ 你之前的路由逻辑我给你完整保留
    pdPower: function (roleStr) {
      // roleStr 是 JSON string
      // 为了兼容你原来的写法：用 indexOf 判断
      if (roleStr.indexOf("admin") !== -1) {
        this.$router.push({ path: "/glyMg" });
      } else {
        if (roleStr.indexOf("business") !== -1) {
          this.$router.push({ path: "/a" });
          return;
        }
        if (roleStr.indexOf("content") !== -1) {
          this.$router.push({ path: "/bmOne" });
          return;
        }
        if (roleStr.indexOf("optimize") !== -1) {
          this.$router.push({ path: "/goods" });
          return;
        }
        // 没匹配到角色，兜底
        this.$router.push({ path: "/a" });
      }
    },
  },
};
</script>

<style lang="less">
.login_page {
  background-color: #ffffff;

  .login-content {
    position: fixed;
    top: 50%;
    left: 50%;
    background-color: #ffffff;
    margin-top: -260px;
    margin-left: 150px;
    width: 350px;
    height: 350px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 12px;

    .login-tit {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }

    .cot_put_box {
      padding: 10px 40px;

      .cot_put {
        margin-bottom: 20px;
      }
    }

    .login-tip {
      color: #999999;
      font-size: 14px;
      margin-top: 20px;
    }
  }
}

.login-lg-btn {
  width: 240px !important;
}

.login-bg {
  min-width: 1200px;

  img {
    height: auto;
    width: 100%;
    min-width: 1200px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/login/index.vue